import { connect } from 'react-redux';

import { IState } from '../../../store';
import { InfoBlock } from './InfoBlock';

export const mapStateToProps = (state: IState) => ({
  agent: state.offerData.agent,
  offerData: state.offerData,
});

export const InfoBlockContainer = connect(mapStateToProps)(InfoBlock);
